import { useViewActions } from '@mm/state/actions/viewActions';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PromoterTypes } from '@mm/state/model/PromoterModel';
import { useCallback } from 'react';
import { NUMERIC_OPTIONS } from '../../../../editor/features/beta/modules/Automations/AutomationHome/TemplateIndex/Templates/Builders/Components/TemplateShared';
import { useCreateCampaignHandlers } from '../../../../editor/features/beta/modules/Campaigns/use-create-campaign-handlers';
import { BotBuilderRoutes } from '../../../../routes/bot-builder-routes';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { CampaignType } from '@mm/state/model/CampaignsModel';

export const useCreateGetemails = () => {
  const { createByKind } = useCreateCampaignHandlers();
  const { showSlideoutMenu } = useViewActions();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const history = useHistory();

  const createGetemailsCampaign = useCallback(
    async (botId: number, navigateToCampaign?: boolean) => {
      const campaign = (await createByKind(
        'automation',
        'email_sold_automation',
        {
          active: false,
          inputTriggers: [{ kind: PromoterTypes.GETEMAILS }],
          unicornEmailQuantity: NUMERIC_OPTIONS[0].id,
          unicornOnly: true,
        },
        botId,
      )) as any as CampaignType;

      if (campaign && navigateToCampaign) {
        history.push(
          BotBuilderRoutes.automationEdit.getLink({
            chatbotId,
            id: campaign.id,
          }),
        );
        const promoter = campaign.campaignAudiencesAttributes?.find(
          attr => attr.promoter?.kind === 'getemails',
        )?.promoter;

        if (promoter) {
          showSlideoutMenu('getemailsEditorNew', {
            promoterId: promoter.id,
          });
        }
      }

      return campaign;
    },
    [createByKind, chatbotId, history, showSlideoutMenu],
  );

  return { createGetemailsCampaign };
};
